import React, { useContext, useEffect, useMemo, useState } from "react";
import { CloseButton, LocalShadow, PopupButton, PopupWrapper } from "../styled/BasicBlocks";
import { AddSessionForm } from "../../pages/dashboardPage/components/sessions/addSession/AddSessionForm";
import { AddSessionFormContexted, AddSessionFormController } from "../../pages/dashboardPage/components/sessions/addSession/AddSessionFormController";
import "./CalendarEventFormTabs.css";
import "./CalendarEventForm.css";
import { IRepeatParams, ITicket } from "../../types/dashboard";
import { SelectTime } from "../selectTime/SelectTime";
import { AddSessionFormContext } from "../../pages/dashboardPage/components/sessions/addSession/AddSessionFormContext";
import { DashboardContext } from "../../pages/dashboardPage/DashboardContext";
import { RepeatOptionsForm } from "../../pages/dashboardPage/components/sessions/addSession/RepeatOptionsForm";
import { AppContext } from "../../appContext";

const AddSessionButtonsContexted = ()=>{
    const {deleteSession, saveSession, editId} = useContext(AddSessionFormContext);
    const {translate} = useContext(AppContext);

    return (
        <div className="CalendarEventForm_buttons">
            {editId && <PopupButton onClick={()=>deleteSession()}>
                {translate('session_delete')}
            </PopupButton>}
            {<PopupButton onClick={()=>saveSession()}>
                {editId ? translate('session_save') : translate('session_create')}
            </PopupButton>}
            {/*eventData && <PopupButton onClick={()=>onSave({
                start: startTime,
                end: endTime,
                title: textInput,
                type: 'event',
                id: eventData.id,
            })}>
                Save
            </PopupButton>*/}
        </div>
    )
}

interface ICalendarCreateEventFormProps{
    eventData?: ITicket;
    clickedDate?: Date;
    onDelete: (data: ITicket, all?: boolean)=>void;
    onSave: (data: ITicket)=>void;
}


const CalendarCreateEventForm = ({ eventData, clickedDate, onDelete, onSave }: ICalendarCreateEventFormProps) => {
    const {translate} = useContext(AppContext);
    const [textInput, setTextInput] = useState('');
    const [startTime, setStartTime] = useState<Date>();
    const [endTime, setEndTime] = useState<Date>();
    const [repeatParams, setRepeatParams] = useState<IRepeatParams>({});
    const isPeriodic = eventData?.original?.ShareId;

    useEffect(()=>{
        if (eventData){
            setTextInput(eventData.title);
            setStartTime(eventData.start);
            setEndTime(eventData.end);
            //setRepeatParams(eventData.original.repeatParams)
           // setCurrentTab(eventData.type);
           // setShowTabs(false);
        } else {
           // setShowTabs(true);
        }
    }, [eventData]);

    useEffect(()=>{
        if (clickedDate && !eventData){
            const end = new Date(clickedDate);
            end.setUTCHours(end.getUTCHours() + 1);
            setEndTime(end);
        }
        if (eventData){
            setEndTime(eventData.end)
            setStartTime(eventData.start)
        }
    }, [clickedDate, eventData]);

    useEffect(()=>{
        if (clickedDate && !eventData){
            const end = new Date(clickedDate);
            setStartTime(end);
        }
    }, [clickedDate, eventData]);

    return <>
        <div className="CalendarEventForm_form">
            <div className="CalendarEventForm_formItem">
                <div className="CalendarEventForm_formItem_label">{translate('calendar_event_start_time')}</div>
                {startTime && <SelectTime selectedDate={startTime || eventData.start} onSelect={(date) => {
                    setStartTime(date)
                }}></SelectTime>}
            </div>
            <div className="CalendarEventForm_formItem">
                <div className="CalendarEventForm_formItem_label">{translate('calendar_event_end_time')}</div>
                {endTime && <SelectTime selectedDate={endTime || eventData.end} onSelect={(date) => {
                    setEndTime(date)
                }}></SelectTime>}
            </div>
            <RepeatOptionsForm repeatParams={repeatParams} onChange={setRepeatParams} numberOfItemsText={translate('repeat_number_of_events')}></RepeatOptionsForm>
            <div className="CalendarEventForm_formItem CalendarEventFormItem--line">
                <div className="CalendarEventForm_formItem_label">{translate('calendar_event_text')}</div>
                <textarea className="CalendarEventForm_textInput" value={textInput} onChange={(e) => { setTextInput(e.target.value) }}></textarea>
            </div>

            
        </div>

        <div className="CalendarEventForm_buttons">
            {isPeriodic && <PopupButton onClick={() => onDelete(eventData, true)}>
                {translate('calendar_event_delete_all')}
            </PopupButton>}
            {eventData && <PopupButton onClick={() => onDelete(eventData)}>
                {translate('session_delete')}
            </PopupButton>}
            {!eventData && <PopupButton onClick={() => onSave({
                start: startTime,
                end: endTime,
                title: textInput,
                type: 'event',
                original: {
                    repeatParams
                }
            })}>
                {translate('session_create')}
            </PopupButton>}
            {eventData && isPeriodic && <PopupButton onClick={() => onSave({
                start: startTime,
                end: endTime,
                title: textInput,
                type: 'event',
                id: eventData.id,
                original: {
                    repeatParams
                },
                editOtherEvents: true
            })}>
                {translate('calendar_event_save_all')}
            </PopupButton>}
            {eventData && <PopupButton onClick={() => onSave({
                start: startTime,
                end: endTime,
                title: textInput,
                type: 'event',
                id: eventData.id,
                original: {
                    repeatParams
                }
            })}>
                {translate('session_save')}
            </PopupButton>}
        </div>
    </>
}

interface ICalendarEventFormProps{
    eventData?: ITicket;
    clickedDate?: Date;
    onClose: ()=>void;
    onDelete: (data: ITicket, all?: boolean)=>void;
    onSave: (data: ITicket)=>void;
}

export const CalendarEventForm = ({eventData, clickedDate, onClose, onDelete, onSave}: ICalendarEventFormProps)=>{
    const [currentTab, setCurrentTab] = useState("event");
    const [showTabs, setShowTabs] = useState(false);
    const {selectedClient} = useContext(DashboardContext);
    const {translate} = useContext(AppContext);

    const defaultEnd = useMemo(()=>{
        const end = new Date(clickedDate);
        end.setUTCHours(end.getUTCHours() + 1);
        return end;
    }, [clickedDate]);

    const [sessionFormData, setSessionFormData] = useState({
        title: '',
        selectedClient: '',
        date: new Date(),
        timeFrom: new Date(),
        timeTo: new Date(),
        repeatParams: {}
    }); 

    useEffect(()=>{ console.log(sessionFormData)},[sessionFormData]);

    useEffect(()=>{
        if (eventData){
            setCurrentTab(eventData.type);
            setShowTabs(false);
        } else {
            setShowTabs(true);
        }
    }, [eventData]);

    const tabs={
        event: {
            tabName: translate('calendar_event_event'),
            element: <CalendarCreateEventForm 
                eventData={eventData}
                clickedDate={clickedDate}
                onDelete={onDelete}
                onSave={onSave}
            ></CalendarCreateEventForm>
        },
        task: {
            tabName: translate('calendar_event_task'),
            element: <CalendarCreateEventForm 
                eventData={eventData}
                clickedDate={clickedDate}
                onDelete={(data, all)=>onDelete({
                    ...data,
                    type: 'task'
                }, all)}
                onSave={(data)=>onSave({
                    ...data,
                    type: 'task'
                })}
            ></CalendarCreateEventForm>
        },
        session: {
            tabName: translate('calendar_event_session'),
            element: <AddSessionFormController
                initialSessionData={eventData?.original || {
                    date: clickedDate,
                    dateTo: defaultEnd,
                    client: selectedClient.id,
                }}
                onSave={(data)=>{
                    onSave({
                        start: new Date(data.date),
                        end: new Date(data.dateTo),
                        type: 'session',
                        title: data.title,
                        original: data
                    })
                }}
                onDelete={(data)=>{
                    onDelete({start: new Date(data.date),
                        end: new Date(data.dateTo),
                        type: 'session',
                        title: data.title,
                        original: data
                    })
                }}
            >
                <div className="CalendarEventForm_sessions">
                    <AddSessionFormContexted></AddSessionFormContexted>
                    <AddSessionButtonsContexted></AddSessionButtonsContexted>
                </div>
            </AddSessionFormController>
        }
    }

    return <LocalShadow className="CalendarEventForm_shadow">
        <PopupWrapper className="CalendarEventForm_wrapper">
            <div className="CalendarEventForm_header">
                <div className="CalendarEventForm_header_title">
                    {eventData ? 
                        (currentTab === 'event' ? translate('calendar_edit_event') :
                         currentTab === 'task' ? translate('calendar_edit_task') :
                         translate('calendar_edit_session')) :
                        (currentTab === 'event' ? translate('calendar_new_event') :
                         currentTab === 'task' ? translate('calendar_new_task') :
                         translate('calendar_new_session'))
                    }
                </div>
                <CloseButton onClick={onClose}></CloseButton>
            </div>

            {showTabs && <div className="CalendarEventFormTabs">
                {Object.keys(tabs).map((tab: keyof typeof tabs)=>{
                    return <div className={`button CalendarEventFormTabs_item ${currentTab == tab ? "CalendarEventFormTabs_item--active" : ""}`} onClick={()=>{
                        setCurrentTab(tab);
                    }}>{tabs[tab].tabName}</div>
                })}
            </div>}

            {tabs[currentTab as keyof typeof tabs].element}

        </PopupWrapper>
    </LocalShadow>
}